import styled from "styled-components";

export const Root = styled.div`
  ${({ theme }) => `
    background: ${theme.palette.background.default};

  `}
`;
